import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// import User from "./user/user";
import Faqs from "./FAQS";
import PriceMaster from "./PriceMaster";

// import OrderDetail from "./order/OrderDetail";
// import Address from "./booking/Address";

export default function master() {
  return (
    <Switch>
      <Redirect exact={true} from="/master" to="/master/user-details" />

      {/* Layout */}
      
      {/* <Route path="/master/user-details" component={User} /> */}
      <Route path="/master/faq" component={Faqs} />
      <Route path="/master/price-master" component={PriceMaster} />

    </Switch>
  );
}
